/* eslint-disable */
import React, { Component } from 'react'


import Svg,{
  Circle,
  Ellipse,
  G,
  LinearGradient,
  RadialGradient,
  Line,
  Path,
  Polygon,
  Polyline,
  Rect,
  Symbol,
 
  Use,
  Defs,
  Stop
} from 'react-native-svg';

export const SvgKargoeCare = ({size}) => {
    return (  <Svg
        viewBox="0 0 236.65 242.15"
        height = {size}
        width = {size}
    >
   <G id="Layer_2" data-name="Layer 2">
   <G id="Layer_1-2" data-name="Layer 1">
   <Polygon fill = "#49536b" class="cls-1" points="10.1 156.87 58.47 147.84 113.46 169.34 149.19 183.45 182.78 183.45 213.02 152.27 230.5 162.62 180.77 234.52 100.81 234.52 55.03 215.15 10.1 211 10.1 156.87"/>
   <Path d="M137.84,242.07c-11.43,0-22.86,0-34.29,0a19.91,19.91,0,0,1-10.18-2.88c-9.58-5.47-19.23-10.83-28.84-16.24a38.3,38.3,0,0,0-17.79-4.64c-10.37-.36-20.75-.72-31.12-.93C6.55,217.24,0,210.75,0,201.63q0-18.71,0-37.42c0-9,6.47-15.65,15.44-15.7,7.37,0,14.24-2.19,21.14-4.38,23.3-7.42,45-4.34,65,9.88,2.74,1.95,5.45,3.93,8.19,5.88,1.82,1.3,3.76,2.45,5.5,3.85,7.3,5.91,15.91,8.31,25,9.32,10.23,1.14,20.48,2.09,30.72,3.12a5,5,0,0,1,1.76.22c2.93,1.58,5,.39,7.18-1.69,6.7-6.39,13.47-12.71,20.39-18.85a57.51,57.51,0,0,1,10.64-8c6.71-3.59,14.3-1.93,19.94,3.55,5.47,5.32,7.23,13,4.29,19.7a27.31,27.31,0,0,1-3.44,5.19c-12.22,16.31-24.51,32.56-36.68,48.91-3,4.05-5.26,8.67-9.47,11.8-4.44,3.3-9.14,5.3-14.86,5.18C159.81,241.91,148.82,242.07,137.84,242.07Zm0-13.83c10.83,0,21.66-.14,32.49.07,4.55.09,7.42-2.15,9.81-5.5,1.34-1.88,2.43-3.95,3.81-5.79q18.72-25,37.51-50c1.64-2.17,1.75-3.55.25-5.36s-3.65-2.41-5.76-1a46.12,46.12,0,0,0-5.32,4.42c-7.65,7-15.23,14.1-22.93,21a3,3,0,0,0-1.14,3.53c2.68,10.19-4.41,20.78-14.92,21.87-7.49.78-15,.94-22.57,1.35-9.69.53-19.39.93-29.07,1.58-3.74.25-7.4.08-10.71-1.57a155.38,155.38,0,0,1-13.84-7.7c-7-4.42-13.86-9-20.65-13.79a8.59,8.59,0,0,1-3-4.23,6.14,6.14,0,0,1,2.39-7,6.21,6.21,0,0,1,7.35-.67c5.6,3.42,11,7.13,16.52,10.68,4.7,3,9.36,6.14,14.2,8.9a11.63,11.63,0,0,0,5.94,1.47c13.5-.56,27-1.34,40.49-2,3.58-.19,7.17-.29,10.73-.61a4,4,0,0,0,0-8.07c-.89-.11-1.79-.15-2.68-.25-11-1.21-22-2.21-32.88-3.72-7-1-14-2.61-20-6.71-6.84-4.67-13.68-9.35-20.44-14.12-16.12-11.39-33.54-13.89-52.27-7.91-8.24,2.63-16.51,5.19-25.31,5.09-1.78,0-2,1-2,2.49q0,18.15,0,36.3c0,1.83.58,2.47,2.45,2.51,10.08.23,20.16.43,30.22.94,6.62.33,13.35.72,19.37,3.92,11.25,6,22.37,12.2,33.61,18.2a12.34,12.34,0,0,0,5.41,1.53C115.85,228.31,126.83,228.24,137.81,228.24Z"/>
   <Path fill = "#6cc" class="cls-2" d="M144,24.09c5.76-5.2,11-10.52,16.87-15.1a40.06,40.06,0,0,1,25.68-9c21.56.2,41.25,16,46,37,2.94,13,.71,25-5.93,36.58C215.75,92.53,200.92,108,184.46,122,173,131.69,160.89,140.53,149,149.66c-3.21,2.46-5.75,2.35-9.06.05-21.54-14.94-41.75-31.43-59.37-50.94a143.82,143.82,0,0,1-19.7-27.65C45,42.05,63,5.63,95.55.55c13.49-2.11,25.08,2,35.25,10.54,4.27,3.59,8,7.78,12,11.7C143.35,23.3,143.82,23.87,144,24.09Z"/>
   </G>
   </G>
    
    </Svg>)
}

